import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getActiveCardRedirectUrl = createSelector(creditCardsState, (creditCards) => creditCards.activeCardRedirectUrl);
